<div class="LicenseRedirectPopup">
    <h2 class="header">{{ popupContent.title }}</h2>
    <div class="fx-column fx-layout-gap-16">
        <div class="fx-column">
            <p>{{ popupContent.description }}</p>

            <p>{{ popupContent.targetDescription }}</p>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <button mat-stroked-button color="primary" (click)="onLogoutClick()" (keydown.enter)="onLogoutClick()">
            Log out
        </button>
        <button
            mat-flat-button
            color="accent"
            class="white"
            (click)="onContinueClick()"
            (keydown.enter)="onContinueClick()"
        >
            {{ popupContent.buttonText }}
        </button>
    </mat-dialog-actions>
</div>
